import { Component, OnInit, Inject } from '@angular/core';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { LigacaoService } from 'src/app/services/ligacao.service';
import { ItemConversaService } from 'src/app/services/item-conversa.service';
import { ItemConversa } from 'src/app/models/item-conversa';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { LigacaoTelemarketing } from 'src/app/models/ligacao-telemarketing';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-cadastrar-ligacao-telemarketing-modal',
  templateUrl: './cadastrar-ligacao-telemarketing-modal.component.html',
  styleUrls: ['./cadastrar-ligacao-telemarketing-modal.component.scss']
})
export class CadastrarLigacaoTelemarketingModalComponent implements OnInit {
  itensConversa: ItemConversa[] = [];
  ligacao: LigacaoTelemarketing = new LigacaoTelemarketing();
  statusItemIndex: boolean[] = [];

  filtroDescricao: string;

  public config: PerfectScrollbarConfigInterface = {};
  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private ligacaoService: LigacaoService,
    private itemConversaService: ItemConversaService,
    private dialogRef: MatDialogRef<CadastrarLigacaoTelemarketingModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.ligacao = new LigacaoTelemarketing();
    if (data) {
      this.ligacao.idIntegrador = data.intTele.idIntegrador;
      this.ligacao.integrador = data.intTele.nome;
      this.ligacao.itensDaConversa = [];
    }
  }

  ngOnInit(): void {
    this.buscarListaItensConversa();
  }

  buscarListaItensConversa() {
    this.carregandoService.mostra('buscarListaItensConversa');

    this.itemConversaService.consultarLista().subscribe(
      itens => {
        this.itensConversa = itens;
        this.carregandoService.esconde('buscarListaItensConversa');
      },
      err => {
        this.carregandoService.esconde('buscarListaItensConversa');
        this.notificacaoService.erro(err);
      }
    );
  }

  addItem(item: ItemConversa) {
    this.ligacao.itensDaConversa.push(item);
  }

  rmItem(item: ItemConversa) {
    this.ligacao.itensDaConversa = this.ligacao.itensDaConversa.filter(p => p.id !== item.id);
  }

  salvar() {
    this.carregandoService.mostra('salvar');

    this.ligacaoService.salvar(this.ligacao).subscribe(
      () => {
        this.carregandoService.esconde('salvar');

        this.dialogRef.close();
      },
      err => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.erro(err);
      }
    );
  }

  validar() {
    return this.ligacao.itensDaConversa !== null && this.ligacao.itensDaConversa !== undefined && this.ligacao.itensDaConversa.length > 0;
  }

  fechar() {
    this.dialogRef.close();
  }
}
